import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddSensorColumnForm from './components/AddSensorColumnForm';
import { reset } from 'redux-form';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import { aqsColumnList, fdsColumnList , aqs2ColumnList,fds2ColumnList, tisColumnList, psColumnList, aqs3ColumnList} from '../../constants/kpiColumn.constant';
import userSettingEnum from '../../constants/userSetting.enum';
import modelEnum from '../../constants/model.enum';
import { toast } from 'react-toastify';
import { formatMessage } from '../../translations/connectedIntlProvider';
import { cloneDeep } from 'lodash';

const AddSensorColumn = (props: any) => {

  let kpis: any = [];
  let selectedColumns: any = [];

  const [columnList, setColumnList] = useState<any>([]);
  const dispatch = useDispatch();;
  const { columnLists, addColumn }: any = useSelector((state: IState) => { return state.column });
  //let localColumnList = props.model.toLowerCase() === modelEnum.AQS.toLowerCase() ? cloneDeep(aqsColumnList) : cloneDeep(fdsColumnList);

  const localColumnListCloner = (model:string) => {
    switch(model){
      case modelEnum.AQS.toLowerCase():
        return cloneDeep(aqsColumnList);
      case modelEnum.FDS.toLowerCase():
        return cloneDeep(fdsColumnList);
      case modelEnum.AQS2.toLowerCase():
        return cloneDeep(aqs2ColumnList);
      case modelEnum.FDS2.toLowerCase():
        return cloneDeep(fds2ColumnList);
      case modelEnum.TIS.toLowerCase():
        return cloneDeep(tisColumnList);       
      case modelEnum.PS.toLowerCase():
        return cloneDeep(psColumnList);       
      default:
        return cloneDeep(aqs3ColumnList);
    }
  }

  let localColumnList = localColumnListCloner(props.model.toLowerCase());

  const GetAndAddColumn = (isSubmitColumn: boolean) => {
    switch (props.from) {
      case 'LineChart': {
        if (isSubmitColumn) {
          switch(props.model.toLowerCase())
          {
            case modelEnum.AQS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnAQS));
              break;
            case modelEnum.FDS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnFDS));
              break;
            case modelEnum.AQS2.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnAQS2));
              break;
            case modelEnum.FDS2.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnFDS2));
              break;    
            case modelEnum.TIS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnTIS));
              break;    
            case modelEnum.PS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnPS));
              break;    
            default:
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnAQS3));
          }
          // if (props.model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
          //   dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnAQS));
          // } else {
          //   dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnFDS));
          // }
        } else {
          switch(props.model.toLowerCase())
          {
            case modelEnum.AQS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS));
              break;
            case modelEnum.FDS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnFDS));
              break;
            case modelEnum.AQS2.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS2));
              break;    
            case modelEnum.FDS2.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnFDS2));
              break;
            case modelEnum.TIS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnTIS));
              break;
            case modelEnum.PS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnPS));
              break;
            default:
              dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS3));
          }
          // if (props.model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
          //   dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnAQS));
          // } else {
          //   dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnFDS));
          // }
        }
        break;
      }

      case 'SensorData': {
        if (isSubmitColumn) {
          switch(props.model.toLowerCase())
          {
            case modelEnum.AQS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnAQS));
              break;
            case modelEnum.FDS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnFDS));
              break;
            case modelEnum.AQS2.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnAQS2));
              break;  
            case modelEnum.FDS2.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnFDS2));
              break;
            case modelEnum.TIS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnTIS));
              break;
            case modelEnum.PS.toLowerCase():
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnPS));
              break;
            default:
              dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnAQS3));
          }
          // if (props.model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
          //   dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnAQS));
          // } else {
          //   dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnFDS));
          // }
        } else {
          switch(props.model.toLowerCase())
          {
            case modelEnum.AQS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS));
              break;
            case modelEnum.FDS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS));
              break;
            case modelEnum.AQS2.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS2));
              break; 
            case modelEnum.FDS2.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS2));
              break;  
            case modelEnum.TIS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnTIS));
              break;  
            case modelEnum.PS.toLowerCase():
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnPS));
              break;  
            default:
              dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS3));
          }
          // if (props.model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
          //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS));
          // } else {
          //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS));
          // }
        }

        break;
      }
    }
  }

  useEffect(() => {
    GetAndAddColumn(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (columnLists.success) {
      if (columnLists.columns.Value) {
        const columnArr = JSON.parse(columnLists.columns.Value);
        if (props.from === 'LineChart') {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          localColumnList = cloneDeep(localColumnList.filter((item: any) => !(item.id === 1 || item.id === 0)));
        }
        localColumnList.forEach((val: any) => {
          columnArr.forEach((val1: any) => {
            if (val.value === val1) {
              val.isChecked = true;
            }
            else if (val.isChecked && !columnArr.includes(val.value)) {
              val.isChecked = false;
            }
          });
        });
      }
      else{
        if (props.from === 'LineChart') {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          localColumnList = cloneDeep(localColumnList.filter((item: any) => !(item.id === 1 || item.id === 0)));
        }
      }
      setColumnList(localColumnList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnLists.success])

  useEffect(() => {
    if (addColumn.success) {
      toast.success(formatMessage('Message_Show/Hide_Column_Updated_Success'));
      onModalClosed();
      dispatch(actions.resetUserSettingState());
      props.columnSave();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColumn.success]);

  useEffect(() => {
    if (addColumn.error) {
      toast.error(formatMessage(addColumn.error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColumn.error])

  const onSubmitForm = async (values: any) => {
    selectedColumns = [];
    let successflag:boolean=true;
    columnList.forEach((val: any) => {
      if (val.isChecked)
        JSON.stringify(selectedColumns.push(val.value));
    });

    if (selectedColumns.length > 6 && props.from === 'LineChart') {
      successflag=false;
      toast.warn(formatMessage('Line_Chart_KPI_Validation'));
    } else if(selectedColumns.length === 0 && props.from === 'LineChart'){
      successflag=false;
      toast.warn(formatMessage('Line_Chart_KPI_Validation_Min'))
    }
      else {
      GetAndAddColumn(true);
    }
    // if(successflag)
    //toast.success(formatMessage('Message_Show/Hide_Column_Updated_Success'));
    //onModalClosed();
  }

  const onModalClosed = () => {
    //dispatch(actions.resetUserSettingState());
    dispatch(actions.resetUsersettingAddState());
    dispatch(reset('AddSensorColumnForm'));
    props.modalClosed();
  }

  const handleCheckChildElement = (event: any) => {
    kpis = columnList;
    if (event.target.value === "SelectAll")
    {
      kpis.forEach((kpi: any) => {
        kpi.isChecked = event.target.checked;
    })
    }
    else{
      kpis.forEach((kpi: any) => {
        if (kpi.value === event.target.value)
          kpi.isChecked = event.target.checked;
      })
    }
  }

  return (
    <React.Fragment>
      {columnLists.columns !== undefined && !columnLists.loading &&
        <AddSensorColumnForm
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          columnList={columnList}
          from={props.from}     
          model={props.model.toLowerCase()}     
          isLoading={addColumn.loading}
          checkChildElement={handleCheckChildElement}
        />
      }
    </React.Fragment>
  );
};

export default AddSensorColumn;
